import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2525176f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "why-bank" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "why-bank-question" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Why choose Easybank?"),
  /*#__PURE__*/_createElementVNode("p", null, " We leverage Open Banking to turn your bank account into your financial hub. Control your finances like never before. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardsWhy = _resolveComponent("CardsWhy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_CardsWhy)
  ]))
}